// extracted by mini-css-extract-plugin
export var container = "layout-module--container--RoCXy";
export var pinnedwrap = "layout-module--pinnedwrap--c2c69";
export var blogContentPinned = "layout-module--blog-content-pinned--vetBu";
export var blogContent = "layout-module--blog-content--GaBpK";
export var content = "layout-module--content--FwTjf";